import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import { usePostById } from "@/hooks/usePostById";
import PostContent from "@/components/community/PostContent";
import { ArrowLeft } from "lucide-react";
import { deletePost } from "@/lib/community";
import { useQueryClient } from "@tanstack/react-query";

export default function Post() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: post, isLoading: postIsLoading } = usePostById(id);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!postIsLoading && !post) {
      navigate("/community", { replace: true });
    }
  }, [navigate, post, postIsLoading]);

  const handleDeletePost = async (id: string) => {
    await deletePost(id);
    queryClient.invalidateQueries({ queryKey: ["posts"] });
    navigate("/community", { replace: true });
  };

  if (!post) return null;

  return (
    <div className="pb">
      <div className="p-2 md:p-6 space-y-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-500 hover:text-primary transition mb-4"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-medium">{t("community.back") || "Назад"}</span>
        </button>
        <PostContent
          post={post}
          onUpdate={() => window.location.reload()}
          onDelete={handleDeletePost}
          commentId={searchParams?.get("comment")}
        />
      </div>
    </div>
  );
}
